import {
    RuleConditionType,
    RuleActionType,
} from "@common/types/transactionRule";
import { ResourceType } from "@common/types/auditLog";

export const KICK_GROUP_NAME = "Kick";
export const KICK_GROUP_ICON = "kick";
export const KICK_GROUP_ORDER = 99;

export const CONDITION_TYPE_TO_RESOURCE_TYPE: Partial<
    Record<RuleConditionType, ResourceType>
> = {
    [RuleConditionType.ENTITY]: ResourceType.ENTITY,
    [RuleConditionType.CATEGORY]: ResourceType.CATEGORY,
    [RuleConditionType.SUGGESTED_CATEGORY]: ResourceType.CATEGORY,
    [RuleConditionType.COUNTERPARTY]: ResourceType.COUNTERPARTY,
    [RuleConditionType.FINANCIAL_ACCOUNTS]: ResourceType.FINANCIAL_ACCOUNT,
    [RuleConditionType.SUBACCOUNTS]: ResourceType.ACCOUNT,
    [RuleConditionType.CLASS]: ResourceType.CLASS,
};

export const ACTION_TYPE_TO_RESOURCE_TYPE: Partial<
    Record<RuleActionType, ResourceType>
> = {
    [RuleActionType.CATEGORY]: ResourceType.CATEGORY,
    [RuleActionType.ENTITY]: ResourceType.ENTITY,
    [RuleActionType.ACCOUNT_ID]: ResourceType.ACCOUNT,
    [RuleActionType.ACCRUAL_ACCOUNT_ID]: ResourceType.ACCOUNT,
    [RuleActionType.CLASS]: ResourceType.CLASS,
    [RuleActionType.COUNTERPARTY]: ResourceType.COUNTERPARTY,
    [RuleActionType.CUSTOMER]: ResourceType.COUNTERPARTY,
};
